import React from 'react';



export const DataMethodology = () => {

    const methodologyList = [
        {
            name: 'Proprietary Data',
            icon: 'fas fa-user-shield',
            description: 'Companies and institutions provide us with their proprietary information relating to investment amounts, stage, date and more. All data is validated through a rigorous process. We also conduct quarterly follow-ups with verified institutions, getting details on all their investments.'
        },
        {
            name: 'Public Data',
            icon: 'fas fa-globe',
            description: 'We continuously gather public announcements and press releases on the investment landscape across our focus geographies.'
        },
        {
            name: 'Engineered Data',
            icon: 'fas fa-cogs',
            description: 'Where information is either incomplete or undisclosed, our proprietary algorithms create estimates for undisclosed data with factors including funding year, company location, investment stage and company industry.'
        }
    ]

    return (
        <div className="section-icon-cards">

            <div className="landing-section-header">

                Data You Can Trust
                {/* Data You Can Trust, Backed by Transparent Methods */}

                <div className="landing-section-subheading text-muted">
                    Get a transparent look at how we collect, verify and structure our data - with systems and checks that give you reliable, actionable intelligence
                </div>

            </div>

            <div className="row justify-content-center">
                {methodologyList.map((item, i) =>
                    <div className="icon-box" key={`methodology-${i}`}>
                        <i className={item.icon}></i>
                        <h5>{item.name}</h5>
                        <p className="text-muted">{item.description}</p>
                    </div>
                )}
            </div>

            <div className="lines-graphic"></div>

        </div>
    )

}